"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var StyledSimpleTable_1 = require("./StyledSimpleTable");
/** @component */
exports.SimpleTable = function (_a) {
    var children = _a.children, caption = _a.caption, cellPadding = _a.cellPadding, rest = tslib_1.__rest(_a, ["children", "caption", "cellPadding"]);
    return (React.createElement(StyledSimpleTable_1.StyledSimpleTable, tslib_1.__assign({ pad: cellPadding }, rest),
        caption ? React.createElement(StyledSimpleTable_1.StyledSimpleTablCaption, null, caption) : null,
        children));
};
exports.SimpleTable.defaultProps = {
    cellPadding: {
        horizontal: 'xsmall',
        vertical: 'xxsmall'
    }
};
//# sourceMappingURL=SimpleTable.js.map